"use client";
import { useState, useMemo } from "react";
import { useAppSelector } from "../../lib/redux/hooks";
import { selectResume } from "../../lib/redux/resumeSlice";
import { selectSettings } from "../../lib/redux/settingsSlice";
import { ResumeControlBar } from "./ResumeControlBar";
import { ResumePDF } from "./ResumePDF";

export const Resume = () => {
  const [scale, setScale] = useState(0.8);
  const resume = useAppSelector(selectResume);
  const settings = useAppSelector(selectSettings);
  
  const document = useMemo(
    () => <ResumePDF resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );

  return (
    <div className="relative flex justify-center md:justify-start h-full">
      <div className="w-12 hidden md:block" />
      <div className="relative flex-1">
        <section className="h-[calc(100vh-var(--top-nav-bar-height)-var(--resume-control-bar-height))] overflow-hidden md:p-6">
          <div className="relative">
            <ResumePDF
              resume={resume}
              settings={settings}
              isPDF={false}
            />
          </div>
        </section>
        <ResumeControlBar
          scale={scale}
          setScale={setScale}
          documentSize={settings.theme.documentSize}
          document={document}
          fileName={resume.profile.name + " - Resume"}
        />
      </div>
    </div>
  );
};
